import { Map } from '../../../Common/Charts/Map';
import { useHouseHoldVisitChartsDataContext } from './hooks/useHouseHoldVisitChartsDataContext';

const EvolutionHouseVisitByCoordinates = () => {
    const { chartData } = useHouseHoldVisitChartsDataContext();

    return (
        <Map chartData={chartData.evolutionHouseVisitByCoordinates} zoom={12} />
    );
};

export default EvolutionHouseVisitByCoordinates;
